var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"scene"},[_c('div',{staticClass:"headline"},[_vm._v(_vm._s(_vm.$t('headline.title7')))]),_c('div',{staticClass:"list"},_vm._l((_vm.list),function(item,index){return _c('div',{key:index,staticClass:"item"},[_c('div',{staticClass:"logo"},[_c('img',{attrs:{"src":item}})])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }